export enum NodeStatus {
  checked = "checked",
  unchecked = "unchecked",
  indeterminate = "indeterminate"
}